import { makeStyles } from "@material-ui/core/styles";
//

//Cart.js
export default makeStyles((theme) => ({
  //
  toolbar: theme.mixins.toolbar,
  //--------------------------------
  //
  //** YOUR SHOPPING CART
  // ** YOUR SELECTION
  //
  title: {
    //
    fontSize: `calc(28px + 1.1vmin)`,
    lineHeight: `calc(29px + 1.1vmin)`,
    color: "#121212", //yellow
    fontFamily: "RobotoBlack",
    textTransform: "uppercase",
    fontWeight: "100",
    letterSpacing: "1px",
    wordSpacing: "10px",
    //
    //
    [theme.breakpoints.down("xs")]: {
      margin: "60px 0 40px 0",
      fontSize: `calc(17px + 1.1vmin)`,
      lineHeight: `calc(8px + 1.1vmin)`,
    },
    [theme.breakpoints.up("sm")]: {
      // color: "red",
      margin: "70px 0 40px 0",
      fontSize: `calc(20px + 1.1vmin)`,
      lineHeight: `calc(8px + 1.1vmin)`,
    },
    [theme.breakpoints.up("md")]: {
      // color: "purple",
      margin: "50px 0 40px 0",
      fontSize: `calc(20px + 1.1vmin)`,
      lineHeight: `calc(8px + 1.1vmin)`,
    },
    [theme.breakpoints.up("lg")]: {
      // color: "green",
      margin: "50px 0 40px 0",
      fontSize: `calc(22px + 1.1vmin)`,
      lineHeight: `calc(8px + 1.1vmin)`,
    },
  },
  //
  //  *** SUBTOTAL
  //
  subTotalTitle: {
    color: "#121212",
    letterSpacing: "2px",
    wordSpacing: "10px",

    fontFamily: "RobotoBlack",
    textTransform: "uppercase",
    fontWeight: "100",
    opacity: "0.7",

    //
    //
    [theme.breakpoints.up("xs")]: {
      // backgroundColor: "yellow",
      fontSize: `calc(14px + 1.1vmin)`,
      lineHeight: `calc(16px + 1.1vmin)`,
    },
    [theme.breakpoints.up("sm")]: {
      // backgroundColor: "red",
    },
    [theme.breakpoints.up("md")]: {
      // backgroundColor: "purple",
    },
    [theme.breakpoints.up("lg")]: {
      // backgroundColor: "purple",
      fontSize: `calc(10px + 1.1vmin)`,
      lineHeight: `calc(16px + 1.1vmin)`,
    },
  },
  //
  //
  // ***  WRAPPER BTN ***
  //
  //
  wrapperEmptyBtnAndCheckoutBtn: {
    width: "100%",
    // backgroundColor: "rgba(255, 40, 0, 0.48)",

    //
    //
    [theme.breakpoints.down("xs")]: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "flex-end",
      flexFlow: "column",
    },
    [theme.breakpoints.up("sm")]: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      flexFlow: "row",
    },
    //
  },
  //
  //
  // *** EMPTY cart BTN
  //
  emptyButton: {
    padding: "0.7em 1.6em",
    fontSize: `calc(4px + 1.1vmin)`,

    //
    border: "2px solid #fbfbfb",
    boxShadow: "10px 11px 0px 1px  rgba(0,0,0,0.88)",
    borderRadius: "8em",
    boxSizing: "borderBox",
    textDecoration: "none",
    fontWeight: "600",
    //
    backgroundColor: "#121212",
    color: "rgb(248,248,248)",
    textAlign: "center",
    transition: "all 0.3s ease-in-out",
    // responsive button and space between this and the other button
    minWidth: "150px",
    //
    //
    //  *** MEDIA querie
    //
    [theme.breakpoints.down("xs")]: {
      marginBottom: "20px",
      padding: "8px 25px",
      minWidth: "80px",
    },
    [theme.breakpoints.up("sm")]: {
      marginRight: "20px",
    },

    // *** Hover Btn
    //
    "&:hover": {
      padding: "0.7em 4em",
      //
      borderRadius: "1em",
      border: "2px solid #121212",
      boxShadow: "10px 11px 0px 1px  rgba(0,0,0,0.88)",
      //"#f3ff71",
      //"#ff0080", //magenta

      backgroundColor: "#fbfbfb",
      color: "#121212",
      //
      [theme.breakpoints.down("xs")]: {
        marginBottom: "5px",
      },
      [theme.breakpoints.up("sm")]: {
        marginRight: "20px",
      },
    },
  },
  //
  //    *** CHECKOUT BUTTON ***
  //
  checkoutButton: {
    //
    color: "#121212",
    backgroundColor: "#00ffb3",
    border: "2px solid #121212",
    boxShadow: "10px 11px 0px 1px  rgba(0,0,0,0.88)",
    borderRadius: "8em",
    //
    //  "#ff0080", //magenta
    //
    padding: "0.7em 1.6em",
    fontSize: `calc(4px + 1.1vmin)`,
    fontWeight: "600",
    boxSizing: "borderBox",
    textDecoration: "none",
    textAlign: "center",
    //
    // *** animation
    transition: "all 0.3s ease-in-out",
    //
    //
    //
    //  *** MEDIA querie
    //
    [theme.breakpoints.down("xs")]: {
      marginBottom: "20px",
      padding: "8px 25px",
      minWidth: "80px",
    },
    [theme.breakpoints.up("sm")]: {},

    //
    //
    "&:hover": {
      padding: "0.7em 4em",
      //
      borderRadius: "1em",
      border: "2px solid #121212",
      boxShadow: "10px 11px 0px 1px  rgba(0,0,0,0.88)",
      backgroundColor: "#f3ff71",
      color: "#121212",
    },
  },

  cardDetails: {
    display: "flex",
    marginTop: "10%",
    width: "100%",
    justifyContent: "space-between",
    margin: "1% 0% 2% 0%",
  },
}));

// https://mui.com/customization/color/
